export default __webpack_public_path__ + "static/media/program_complete_001.5c7d07f2.png";